import type { FaireProductEntity } from "../../entity_types/product";

export const p_nu8qh54b3a: FaireProductEntity = {
  token: "p_nu8qh54b3a",
  type: "product",
  name: "Sugar Squishies® Mini Maltose Fidget Toys 24-Day Advent Countdown Calendar (24pc)",
  brandToken: "b_8688sz59tv",
  brandName: "Showcase",
  imageUrl:
    "https://cdn.faire.com/fastly/12916f06fec5c008f0e46350d993746227f9a554324dc0a2bf5c200b19c1c796.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/7cdf5898ea471330c9d75ea1945c874984f0cc26b624aae11b50173112645995.jpeg",
    "https://cdn.faire.com/fastly/7f63a78762b65d3c6d98ff434c611a8329045f4b3132a829db99fe87a95280b0.jpeg",
    "https://cdn.faire.com/fastly/2b41e87ecfbb9a5eb6d64cad2b845335140d6fa7618168a14af4e2147b2ff3d7.jpeg",
    "https://cdn.faire.com/fastly/daaad408404890afba83cdcb30b2c771e7672776bc069963f93ed8f89de6256b.jpeg",
    "https://cdn.faire.com/fastly/c50fd1faf9f0437b279c830d398b771838dd3c3252dec8281d81aeb16e4c0e68.jpeg",
    "https://cdn.faire.com/fastly/faa2c292cdd4a18f594c8f9f5dcf38407c8780f193e383135c6c6020995c1cbb.jpeg",
    "https://cdn.faire.com/fastly/45c2cad70142a7b8034d03dc8703caee64000aa571552249319011a86b875fcc.jpeg",
  ],
  priceDollars: 19.99,
  description:
    "🎁 Your Q4 Secret Weapon Is Here!\n\nThe SugarSqueez® Mini Maltose Fidget Toys 24-Day Advent Countdown Calendar is one of the most giftable, sellable, and repeatable holiday items you can stock this season.\n\nBehind every numbered door is a unique miniature squishy filled with smooth maltose, delivering the signature slow-mold \"Sugar Squeeze\" sensation customers can't put down. \n\n24 different designs. Zero duplicates. Maximum collectible appeal.\n\nThis is a blind box and advent calendar in one, two of the biggest impulse drivers in retail today, wrapped up in a holiday format that sells itself at the register.\n\n✅ Irresistible as a standalone gift\n\n✅ Perfect stocking stuffer alternative\n\n✅ Drives repeat visits as customers collect the full set\n\n✅ Appeals to kids, teens, and adults equally\n\n✅ Compact display footprint, massive shelf impact\n\nEach squishy measures approximately 1.2 to 1.6 inches, pocket sized and grab and go ready.\n\nQ4 shelf space is precious. This is the kind of item that earns its spot fast and keeps moving all season long. Retailers who stock it early won't be restocking it late. 🔥",
  tags: [],
  msrpDollars: 39.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:52:28.977Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
